import script from "./SelectionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectionPage.vue?vue&type=script&setup=true&lang=ts"

import "./SelectionPage.vue?vue&type=style&index=0&id=5c433012&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c433012"]])

export default __exports__